export default __webpack_public_path__ + "static/analy-ee95e8c47aecde189343179d703e1819.jpg";